module.exports = __webpack_public_path__ + "img/Group 1.fe04ffd0.svg";